module.exports = __webpack_public_path__ + "img/isotipo-M-white.92f5360a.svg";